export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST'
export const SET_USER_DATA = 'SET_USER_DATA'
export const FETCH_UPDATE_USER_REQUEST = 'FETCH_UPDATE_USER_REQUEST'
export const FETCH_DELETE_USER_REQUEST = 'FETCH_DELETE_USER_REQUEST'
export const FETCH_UPDATE_CREDIT_CARD_REQUEST = 'FETCH_UPDATE_CREDIT_CARD_REQUEST'
export const FETCH_DELETE_CREDIT_CARD_REQUEST = 'FETCH_DELETE_CREDIT_CARD_REQUEST'
export const FETCH_CREDIT_CARD_REQUEST = 'FETCH_CREDIT_CARD_REQUEST'
export const SET_CREDIT_CARD_DATA = 'SET_CREDIT_CARD_DATA'
